import {PROPERTY_ROOM_FIELDS, propertyDetailsPayload} from './propertyDetailsModel';

export const JOB_TIME_ZONE = 'Australia/Melbourne';
const dateFormatter = new Intl.DateTimeFormat('en-AU', {
    timeZone: JOB_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
});
const timePattern = /^([01]\d|2[0-3]):[0-5]\d$/;

export function jobDateKey(date = new Date()) {
    const parts = Object.fromEntries(dateFormatter.formatToParts(date).map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day}`;
}

export function isValidJobDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '') || value < jobDateKey()) return false;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

export function emptyPropertyJobDraft() {
    return {check_in: '', checklists: []};
}

export function propertyJobErrors(section, jobDraft) {
    const value = section?.value;
    if (!value) return {full_address: 'Load property details before creating a Job.'};
    const errors = {};
    const required = {full_address: 'Address', cos_customer_name: 'Customer name', agent_name: 'Agent name',
        phone: 'Phone', email: 'Email', description: 'Description'};
    for (const [field, label] of Object.entries(required)) {
        if (!String(value[field] ?? '').trim()) errors[field] = `${label} is required to create a Job.`;
    }
    if (value.full_address !== section.baseline?.full_address) {
        errors.full_address = 'Use Update Property to save the address before creating a Job.';
    }
    if (!value.job_type || value.job_type.toLowerCase() === 'task' || !section.jobTypes?.includes(value.job_type)) {
        errors.job_type = 'Select a cleaning job type.';
    }
    const cleaningType = jobDraft.cleaning_type_id == null
        ? section.cleaningTypes?.find(option => option.is_default)
        : section.cleaningTypes?.find(option => option.id === jobDraft.cleaning_type_id);
    if (!cleaningType || cleaningType.status !== 'ACTIVE') errors.cleaning_type_id = 'Select an active Job Type.';
    if (!value.consumable_type || !section.consumableTypes?.includes(value.consumable_type)) {
        errors.consumable_type = 'Select a consumable option.';
    }
    if (!timePattern.test(value.check_out)) errors.check_out = 'Select a valid check-out time.';
    if (jobDraft.check_in && !timePattern.test(jobDraft.check_in)) errors.check_in = 'Select a valid check-in time.';
    for (const field of PROPERTY_ROOM_FIELDS) {
        if (value[field] === '' || value[field] == null || !Number.isFinite(Number(value[field])) || Number(value[field]) < 0) {
            errors[field] = 'Enter zero or a positive number.';
        }
    }
    if (value.checklist_revision == null) errors.checklists = 'Reload property details before creating a Job.';
    return errors;
}

export function propertyJobPayload(property, draft, date) {
    const payload = propertyDetailsPayload(property);
    // The create endpoint also saves PROPERTY templates; sending only JOB items would erase them.
    payload.checklists = [...payload.checklists, ...draft.checklists
        .filter(item => item.description.trim())
        .map(item => ({description: item.description, level: 'JOB', completed: false}))];
    payload.date = date;
    if (draft.cleaning_type_id != null) payload.cleaning_type_id = draft.cleaning_type_id;
    if (draft.check_in) payload.check_in = draft.check_in;
    return payload;
}
